"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GiftVideoUrlBlockedComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    gradIcon: {
      color: palette.orange.main,
      marginRight: spacing(1)
    },
    message: {
      wordBreak: 'break-word',
      color: palette.orange.main,
      fontFamily: 'Lato',
      fontSize: 12,
      fontWeight: 500
    }
  };
});

var GiftVideoUrlBlockedComponent = function GiftVideoUrlBlockedComponent() {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    pt: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex"
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    icon: "info-circle",
    className: classes.gradIcon
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.message
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, "Your admin has set a default video for this campaign."), /*#__PURE__*/_react.default.createElement(_material.Box, null, "It will override your message on landing pages."))));
};

exports.GiftVideoUrlBlockedComponent = GiftVideoUrlBlockedComponent;
GiftVideoUrlBlockedComponent.propTypes = {};
var _default = GiftVideoUrlBlockedComponent;
exports.default = _default;